/**
 * quietShell / /pwa 路由判断（纯函数，不依赖 Pinia）。
 */

/** 是否应按安静壳跳过游客营销弹窗 */
export function shouldSkipGuestPromptForRoute(options = {}) {
  if (options.quietShell || options.fullscreenRoute) return true;
  const routePath = String(options.routePath ?? '')
    .split('?')[0]
    .split('#')[0];
  if (routePath.startsWith('/auth/')) return true;
  if (routePath === '/pwa' || routePath.startsWith('/pwa/')) return true;
  return false;
}
